remitRegisterModule.controller('remitRegisterController',
    ['$scope', '$sce', 'growl', 'AppSettings', 'remit', 'remittanceSheet', 'imSessionVarsService',
        'remitRegisterService','userAuthenticateService','$interval', '$window', '$animate','providerFeaturesService','RemitAccessTypes',
    function ($scope, $sce, growl, AppSettings, remit, remittanceSheet, imSessionVarsService,
                remitRegisterService, userAuthenticateService, $interval, $window, $animate, providerFeaturesService, RemitAccessTypes) {

        $scope.selectedRemittancePeriod = null;
        $scope.remittancePeriods = null;
        $scope.selectedRegisterContract = null;
        $scope.remitRegisterContracts = null;
        $scope.remitRegisterTotal = 0;
        $scope.exportExcelUrl = null;
        $scope.remitContractsCount = 0;
        $scope.remitTotalNumRecs = 0;
        $scope.startIndex=1;
        $scope.pageSize = 50;
        $scope.totalNumberOfPages = 0;
        $scope.numOfPagesAsArray = [];
        $scope.currentPage = 0;
        $scope.status = null;
        $scope.pageTitle = 'Search Contracts';
        $scope.mastheadShowSearch = true;

        $scope.searchParameters ={
            startDate : getDateInPreviousMonth(new Date()),
            endDate : new Date(),
            firstName: null,
            lastName: null,
            vin: null,
            contractNumber: null
        };
        $scope.pager = {};

        $scope.contractStatus= [
            {
                "statusName": "OFFICIAL",
                "val": "OFFICIAL",
                "checked":true
            }];

        $scope.providerAllowsRemit = false;
        $scope.providerAllowsVoid = false;
        $scope.providerAllowsConfirm = false;


        $scope.showPageRange = function(recordCount) {
            //Set indices for pagination and display
            if ($scope.searchedContracts.length < 1) {
                return;
            }
            if (($scope.pager != null) && ($scope.pager.hasOwnProperty('startIndex') || ($scope.pager.startIndex)))
            {
                //set startIndex to send to service to retrieve next batch of records
                $scope.pager.startIndex = $scope.pager.endIndex + 1 ;
                var newEndIndex = $scope.pager.startIndex + $scope.pageSize-1;
                $scope.pager.endIndex = newEndIndex > $scope.remitTotalNumRecs ? $scope.remitTotalNumRecs :newEndIndex;
            }
            else {
                $scope.pager = InitializeSearch($scope.searchedContracts.length);
            }
        };


        function InitializeSearch(searchedContractsLength) {
            //InitializeSearch on Search click
            var endIndex = searchedContractsLength < $scope.pageSize ? searchedContractsLength : $scope.pageSize;

            // return object with all pager properties required by the view
            return {
                pageSize: $scope.pageSize,
                startIndex: 1
            };
        }


        function getDateInPreviousMonth(date) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate() - 30);
        }

        this.init = function() {
            if (imSessionVarsService.getShowcaseIntegrated() == 'true' )
                $scope.mastheadShowSearch = false;
            $scope.remittancePeriods = [];
            $scope.remitRegisterContracts = [];
            $scope.loadRemittancePeriods();

            providerFeaturesService.getProviderApplicationSetting(RemitAccessTypes.AllowRemittance,'false')
                .then(
                    function(element){
                        $scope.providerAllowsRemit = element.toString().toUpperCase() === "TRUE";
                    }
                );
            providerFeaturesService.getProviderApplicationSetting(RemitAccessTypes.AllowVoid,'false')
                .then(
                    function(element){
                        $scope.providerAllowsVoid = element.toString().toUpperCase() === "TRUE";
                        if ($scope.providerAllowsVoid && _.find($scope.contractStatus,function(elem){return elem.statusName === 'VOIDED';})==null){
                            $scope.contractStatus.push(
                                {
                                    "statusName": "VOIDED",
                                    "val": "VOIDED"
                                }
                            );
                        }
                    }
                );
                providerFeaturesService.getProviderApplicationSetting(RemitAccessTypes.AllowConfirm,'false')
                .then(
                    function(element){
                        $scope.providerAllowsConfirm = element.toString().toUpperCase() === "TRUE";
                        if ($scope.providerAllowsConfirm && _.find($scope.contractStatus,function(elem){return elem.statusName === 'CONFIRMED';})==null){
                            $scope.contractStatus.push(
                                {
                                    "statusName": "CONFIRMED",
                                    "val": "CONFIRMED"
                                }
                            );
                        }

                    }
                );
        }


    //
    //----------------- contract search portion ----------------
    //
    $scope.searchContractQuery = '';
    $scope.previousContractQuery = '';

    $scope.contractSearching = false;
    $scope.gettingMoreContracts = false;
    $scope.contractSearchDone = false;
    $scope.searchedContracts = [];
    $scope.mastheadShowSearch = false;
    $scope.notSearched = true;
    $scope.inputsFocused = false;

    $scope.inputsFocusedToggle = function(value){
        $scope.inputsFocused = value;
    };

    $scope.searchOfficialContracts = function(index, msg, iserr) {
        $scope.notSearched = false;
        if( index === 1 ){
            $scope.searchedContracts = [];
            $scope.contractSearching = true;
        } else {
            $scope.gettingMoreContracts = true;
        }
        var contractStatus = "";
        //reset our Index and pager
        if(index == 1)
        {
            $scope.pager = {};
        }
        else {
            $scope.pager.startIndex = $scope.pager.endIndex;
            }

        remitRegisterService.searchContracts($scope.searchParameters.startDate, $scope.searchParameters.endDate, $scope.searchParameters.firstName, $scope.searchParameters.lastName, $scope.searchParameters.vin, $scope.searchParameters.contractNumber, $scope.pager.endIndex,   $scope.pageSize, $scope.status )
        .then(
            function gotSearchResults(results){
                //$scope.searchedContracts = results.records;
                _.each(results.records, function(record){
                    $scope.searchedContracts.push(record);
                });
                $scope.remitTotalNumRecs = results.totalNumRecs;
                $scope.contractSearching = false;
                $scope.gettingMoreContracts = false;
                $scope.showPageRange($scope.pageSize);
                if (msg){
                    if (iserr)
                        growl.error(msg);
                    else
                        growl.warning(msg);
                }
            }
        );
        $scope.inputsFocused = false;
    };


    $scope.finalizeContracts = {};

    $scope.contractSearching = false;
    $scope.contractSearchDone = false;
    $scope.searchedContracts = [];
    $scope.mastheadShowSearch = false;
    $scope.notSearched = true;
    $scope.inputsFocused = false;

    $scope.inputsFocusedToggle = function(value){
        $scope.inputsFocused = value;
    };

    $scope.searchOfficialContracts = function(index, msg) {
        $scope.notSearched = false;
        $scope.searchedContracts = [];
        $scope.contractSearching = true;
        var contractStatus = "";
        //reset our Index and pager if initial search - We are passing 0 in to distinguish it from paginated search
        if(index == null)
        {
            $scope.pager = {};
            $scope.totalNumberOfPages = 0;
            $scope.numOfPagesAsArray = [];
            $scope.currentPage = 0;
        }
        else {
            $scope.pager.endIndex = index;
        }

        remitRegisterService.searchContracts($scope.searchParameters.startDate, $scope.searchParameters.endDate, $scope.searchParameters.firstName, $scope.searchParameters.lastName, $scope.searchParameters.vin, $scope.searchParameters.contractNumber, true, $scope.pager.endIndex,   $scope.pageSize, $scope.status )
            .then(
                function gotSearchResults(results){
                    //$scope.searchedContracts = results.records;
                    _.each(results.records, function(record){
                        $scope.searchedContracts.push(record);
                    });
                    $scope.remitTotalNumRecs = results.totalNumRecs;
                    // If we have more records than the page size, set pagination vars
                    if( $scope.remitTotalNumRecs > $scope.pageSize ){
                        $scope.totalNumberOfPages = Math.ceil($scope.remitTotalNumRecs / $scope.pageSize);
                        for(var index = 0; index < $scope.totalNumberOfPages; index++){
                            $scope.numOfPagesAsArray.push(index);
                        }
                    }
                    $scope.contractSearching = false;
                    $scope.showPageRange($scope.pageSize);
                    if (msg){
                        growl.warning(msg);
                    }
                }
            );
        $scope.inputsFocused = false;
    };

    $scope.finalizeContracts = {};

    $scope.toggleSelectContract = function(contractId){
        $scope.finalizeContracts[contractId] = $scope.finalizeContracts[contractId] ? ($scope.finalizeContracts[contractId].checked ? {checked : false} : {checked : true}) : {checked : true};
        $scope.getTotalNumberSelectedContracts();
    };

    $scope.finalizeSelectedContracts = function(){
        var contractIds = [];

        angular.forEach($scope.finalizeContracts, function(value, key){
            if (value.checked) {
                contractIds.push(key);
                value.checked = !value.checked;
            }
        });

        //$scope.remitContractsCount = contractIds.length;

        remitRegisterService.finalizeContracts(contractIds)
            .then(
                function done(){
                    $scope.searchOfficialContracts();
                    $scope.loadRemitRegisterContracts();

            }
            )
    }

            $scope.getRemitSheet = function() {
                var registerId = getSelectedRemitRegisterId();

                remitRegisterService.getRemitSheet(registerId);
            };

            var exportCount = 0;    // force each export to request data again (prevent caching)

            $scope.exportToExcel = function() {
                var registerId = getSelectedRemitRegisterId();
                var registerUrl =  AppSettings.startSPANPlusSvcURL + 'remitregister/' + registerId + '?format=excel';

                $scope.displayContract([registerUrl]);
                //remitRegisterService.constructRemitSheetExportUrl(registerId)
                //    .then(
                //        function gotExcelResults(results){
                //results +=  "&_n=" + ++exportCount;
                //$scope.exportExcelUrl = $sce.trustAsResourceUrl(results);
                //            $scope.displayContract(results);
                //        }
                //    )

                ///////
                //$scope.displayContract = function(urls){
                //    var urls = angular.isArray(urls) ? urls : [urls]

                //    var authParam = {
                //        "auth": userAuthenticateService.getUserToken()
                //    }

                // add authorization as qs param.  Note that payment agreement urls already have a qs param for contract type.
                //    var authedUrls = urls.map(function(url) { return URI(url).addSearch(authParam).toString();  });

                /*var stop = $interval(function() {
                 //var url = authedUrls.pop();
                 var url = $scope.exportExcelUrl;
                 if (url) { window.open(url, '_blank'); }
                 else {
                 //authedUrls = null;
                 $interval.cancel(stop);
                 stop=null;
                 }
                 }, 100);*/
                //}

                ///////
            };

            /*$scope.$on("__local_open_win", function(event, args) {
             var newWin = $window.open(args.url, args.tab);
             });*/

            $scope.exportContractToExcel = function() {
               // var registerId = getSelectedRemitRegisterId();
                var registerUrl =  ''
                remitRegisterService.searchContracts($scope.searchParameters.startDate, $scope.searchParameters.endDate, $scope.searchParameters.firstName, $scope.searchParameters.lastName, $scope.searchParameters.vin, $scope.searchParameters.contractNumber, true, $scope.currentPage,   $scope.pageSize, $scope.status , 'excel')
                    .then(
                        function gotSearchResults(results){
                            registerUrl=  results.url;
                            $scope.displayContract([registerUrl]);
                        }
                    );


            }


            $scope.finalizedRegister = function(){
                var registerId = getSelectedRemitRegisterId();
                var currentRegister = {dealerInfoId: $scope.selectedRemittancePeriod.dealerInfoId,
                    providerRemitCategoryId: $scope.selectedRemittancePeriod.providerRemitCategoryId,
                    startDate: new Date($scope.selectedRemittancePeriod.startDate),
                    closeDate: new Date(),
                    isSpp: $scope.selectedRemittancePeriod.isSpp,
                    remitRegisterXml: $scope.selectedRemittancePeriod.remitRegisterXML};
                remitRegisterService.closeRemitSheet(registerId, currentRegister)
                    .success(function(responseData, status){
                        //If success closing the current Remit, then we need to create a new current remit
                        $scope.loadRemittancePeriods();
                    })
                    .error(function(responseData, status){
                        growl.error("Error closing the current remittance period");
                    });
            };

            $scope.viewContract = function($event, $index, contractId){
                console.log($event.target, $index);
                var contractUrl = AppSettings.startSPANPlusSvcURL + 'productcontracts/get-pdf/' + contractId;
                console.log('contract id is ' + contractId);

                $scope.displayContract([contractUrl]);
            };

            $scope.displayContract = function(urls){
                var urls = angular.isArray(urls) ? urls : [urls]

                var authParam = {
                    "auth": userAuthenticateService.getUserToken()
                }

                var authedUrls = urls.map(function(url) { return URI(url).addSearch(authParam).toString();  });

                var stop = $interval(function() {
                    var url = authedUrls.pop();
                    if (url) { window.open(url, '_blank'); }
                    else {
                        authedUrls = null;
                        $interval.cancel(stop);
                        stop=null;
                    }
                }, 100);
            }

    $scope.voidSelectedContracts = function(){
        $scope.contractSearching = true;

        var contractIds = [];

        angular.forEach($scope.finalizeContracts, function(value, key){
            if (value.checked) {
                contractIds.push(key);
                value.checked = !value.checked;
            }
        });

        //$scope.remitContractsCount = contractIds.length;

        remitRegisterService.getProviderContractVoidStatus()
        .then(
            function(resp){
                var statid = resp.contractStatusId

                remitRegisterService.voidContractsMulti(contractIds, statid)
                .then(
                    function done(resp){
                        $scope.searchOfficialContracts(0, "Contract(s) Voided.");
                    },
                    function err(err){
                        $scope.searchOfficialContracts(1, "1 or More Contract(s) NOT Voided." + err, true);
                    }
                );
            },
            function err(err){
                $scope.searchOfficialContracts(1, "1 or More Contract(s) NOT Voided." + err, true);
            }
        );
    }
    //
    // ------------------------- end searching portion --------------------------
    //

    $scope.loadRemitRegisterContracts = function() {
        var registerId = getSelectedRemitRegisterId();

        remitRegisterService.getRemitSheet(registerId)
            .success(function(responseData, status){
                $scope.remitRegisterTotal = 0;
                $scope.remitRegisterContracts = [];

                if (responseData.length > 0) {
                    _.each(responseData, function (remitContract) {
                        var tempRemittanceSheet = new remittanceSheet();
                        tempRemittanceSheet.populateFromObject(remitContract, function (err, transformedData) {
                            if(err)
                                growl.error("Error retrieving remittance information: " + err);
                            $scope.remitRegisterContracts.push(transformedData);
                            $scope.remitRegisterTotal = ($scope.remitRegisterTotal + transformedData.dealerAmount);
                        });
                    });
                    $scope.remitContractsCount = contractIds.length;
                }
                else
                    $scope.remitRegisterContracts = [];
            })
            .error(function(responseData, status){
                growl.error("Error retrieving remit contracts");
            });
    };

    $scope.loadRemittancePeriods = function() {
        remitRegisterService.getRemittancePeriods()
            .success(function(responseData, status) {
                if (responseData.totalItemCount > 0) {
                    $scope.remittancePeriods = [];
                    _.each(responseData.itemList, function(remittancePeriod){
                        var tempRemittancePeriod = new remit();
                        tempRemittancePeriod.populateDataFromIdentityManagement(remittancePeriod, function(err, transformedData){
                            if (err)
                                growl.error('Error transforming remittance Periods ' + err);
                            $scope.remittancePeriods.push(tempRemittancePeriod);
                        });
                    });
                    $scope.selectedRemittancePeriod = $scope.remittancePeriods[0];
                    $scope.loadRemitRegisterContracts();
                }
                else {
                    remitRegisterService.createRemittancePeriod()
                        .success(function(responseDataCreate, status){
                            var tempNewRemittancePeriod = new remit();
                            tempNewRemittancePeriod.populateDataFromIdentityManagement(responseDataCreate, function(err, transformedData){
                                if (err)
                                    growl.error('Error transforming new remittance Period ' + err);
                                $scope.remittancePeriods.push(tempNewRemittancePeriod);
                            });
                            //$scope.remittancePeriods[0] = responseDataCreate;
                            $scope.selectedRemittancePeriod = $scope.remittancePeriods[0];
                            $scope.loadRemitRegisterContracts();
                        })
                        .error(function(responseDataCreate, status){
                            growl.error("Error creating the remittance period");
                        });
                }

            })
            .error(function(responseData, status) {
                growl.error("Error retrieving remittance periods");
            });

    };

    $scope.selectedContract = function(contract){
        $scope.selectedRegisterContract = contract;
    };

    $scope.allContractsSelected = false;

    $scope.toggleSelectAllContracts = function(){
        var numSelectedContracts = 0;
        $scope.allContractsSelected = !$scope.allContractsSelected;
        $scope.selectedRegisterContract = {};
        _.each($scope.searchedContracts, function(contract){
            //$scope.selectedRegisterContract[contract.contractId]['checked'] = !$scope.allContractsSelected;
            $scope.finalizeContracts[contract.contractId] = {checked : $scope.allContractsSelected};
            if( $scope.allContractsSelected === true ){ numSelectedContracts ++ }
        });
        $scope.totalNumberSelectedContracts = numSelectedContracts;
    };

    function getSelectedRemitRegisterId() {
        // Todo: need to return the register id of the register that is actually selected
        //return 7263;  // For now, this is the register id of a register of Moritz Cadillac BMW, in UAT
        return $scope.selectedRemittancePeriod.dealerRemitRegisterId;
    }

    $scope.removeContractFromRegister = function() {
        var contractId = $scope.selectedRegisterContract.dealerSavedContractId;
        var registerId = getSelectedRemitRegisterId();
        remitRegisterService.deleteContractFromRegister(contractId, registerId )
            .success(function(responseData, status){
                if (responseData.msg === "Success")
                {
                    $scope.loadRemitRegisterContracts();
                }
                else
                    growl.error("Error removing the contract from the register");
            })
            .error(function(responseData, status){
                growl.error("Error removing the contract from the register");
            });
    };

    $scope.changeRemittancePeriod = function() {
        if ($scope.selectedRemittancePeriod != null)
            $scope.loadRemitRegisterContracts();
    };

    $scope.getRemitSheet = function() {
        var registerId = getSelectedRemitRegisterId();

        remitRegisterService.getRemitSheet(registerId);
    };

    var exportCount = 0;    // force each export to request data again (prevent caching)

    $scope.exportToExcel = function() {
        var registerId = getSelectedRemitRegisterId();
        var registerUrl =  AppSettings.startSPANPlusSvcURL + 'remitregister/' + registerId + '?format=excel';

        $scope.displayContract([registerUrl]);
        //remitRegisterService.constructRemitSheetExportUrl(registerId)
        //    .then(
        //        function gotExcelResults(results){
        //results +=  "&_n=" + ++exportCount;
        //$scope.exportExcelUrl = $sce.trustAsResourceUrl(results);
        //            $scope.displayContract(results);
        //        }
        //    )

        ///////
        //$scope.displayContract = function(urls){
        //    var urls = angular.isArray(urls) ? urls : [urls]

        //    var authParam = {
        //        "auth": userAuthenticateService.getUserToken()
        //    }

        // add authorization as qs param.  Note that payment agreement urls already have a qs param for contract type.
        //    var authedUrls = urls.map(function(url) { return URI(url).addSearch(authParam).toString();  });

        /*var stop = $interval(function() {
            //var url = authedUrls.pop();
            var url = $scope.exportExcelUrl;
            if (url) { window.open(url, '_blank'); }
            else {
            //authedUrls = null;
            $interval.cancel(stop);
            stop=null;
            }
            }, 100);*/
        //}

        ///////
    };

    /*$scope.$on("__local_open_win", function(event, args) {
        var newWin = $window.open(args.url, args.tab);
        });*/

    $scope.finalizedRegister = function(){
        var registerId = getSelectedRemitRegisterId();
        var currentRegister = {dealerInfoId: $scope.selectedRemittancePeriod.dealerInfoId,
            providerRemitCategoryId: $scope.selectedRemittancePeriod.providerRemitCategoryId,
            startDate: new Date($scope.selectedRemittancePeriod.startDate),
            closeDate: new Date(),
            isSpp: $scope.selectedRemittancePeriod.isSpp,
            remitRegisterXml: $scope.selectedRemittancePeriod.remitRegisterXML};
        remitRegisterService.closeRemitSheet(registerId, currentRegister)
            .success(function(responseData, status){
                //If success closing the current Remit, then we need to create a new current remit
                $scope.loadRemittancePeriods();
            })
            .error(function(responseData, status){
                growl.error("Error closing the current remittance period");
            });
    };

    $scope.viewContract = function($event, $index, contractId){
        console.log($event.target, $index);
        var contractUrl = AppSettings.startSPANPlusSvcURL + 'productcontracts/get-pdf/' + contractId;
        console.log('contract id is ' + contractId);

        $scope.displayContract([contractUrl]);
    };

    $scope.displayContract = function(urls){
        var urls = angular.isArray(urls) ? urls : [urls]

        var authParam = {
            "auth": userAuthenticateService.getUserToken()
        }

        var authedUrls = urls.map(function(url) { return URI(url).addSearch(authParam).toString();  });

        var stop = $interval(function() {
            var url = authedUrls.pop();
            if (url) { window.open(url, '_blank'); }
            else {
                authedUrls = null;
                $interval.cancel(stop);
                stop=null;
            }
        }, 100);
    }

    $scope.$on("__local_open_win", function(event, args) {
        var newWin = $window.open(args.url, args.tab);
    });

    $scope.remitSearchOpen = true;
    $scope.remitRegisterOpen = false;
    $scope.allSearchedContractsSelected = false;
    $scope.displayRecordsCount = 25;
    $scope.contractFilter = {
        official: 'OFFICIAL',
        confirmed: 'CONFIRMED',
        voided: 'VOIDED'
    };

    $scope.getStatusOptions = function (choice) {
        var contrStatus = '';
        $scope.status = "";
        // var keys = Object.keys(choice);
        for (var i =0; i<choice.length; i++) {
            if (i > 0 && choice[i].checked)
            {//add our ',' with status name
                $scope.status +=  ', ';
                $scope.status += choice[i].statusName;
            }
            else {
                if (choice[i].checked)
                    $scope.status += choice[i].statusName;
            }
        }

    };

    $scope.contractsFilters = function(contract){
        return contract.contractStatusName == $scope.contractFilter.official ||
            contract.contractStatusName == $scope.contractFilter.confirmed ||
            contract.contractStatusName == $scope.contractFilter.voided;
    };

    $scope.toggleRemitWindows = function ($event, tabIndex) {

        if(tabIndex === 1) {
            $scope.remitSearchOpen = true;
            $scope.remitRegisterOpen = false;
            $scope.pageTitle = 'Search Contracts';
        } else {
            $scope.remitSearchOpen = false;
            $scope.remitRegisterOpen = true;
            $scope.pageTitle = 'Remit Register';
        }
        if ($event) {
            $event.stopPropagation();
        }
    };

    $scope.goPreviousView = function(){
        $window.history.back();
    };

    $scope.showVoidMessageModal = false;

    $scope.totalNumberSelectedContracts = 0;
    $scope.getTotalNumberSelectedContracts = function(){
        var count = 0;
        for( var contract in  $scope.finalizeContracts ){
            $scope.finalizeContracts[contract].checked ? count++ : null;
        }
        $scope.totalNumberSelectedContracts = count;
    };


    $scope.toggleShowVoidMessageModal = function(state){
        $scope.getTotalNumberSelectedContracts();

        if(state === 'open'){
            $scope.showVoidMessageModal = true;
        } else if (state === 'close') {
            $scope.showVoidMessageModal = false;
        }
    };

    $scope.voidContracts = function(){
        console.log('Contracts voided');
    };

    $scope.setCurrentPage = function(page){
        $scope.currentPage = page;
    };

    this.init();
}]);
